import type { Richtext, RichtextContent, RichtextContentWithChildContent } from '@storyblok-types';
type RichtextUnion = RichtextContent | Richtext;

export function extractText(content: Array<RichtextUnion> | undefined) {
  if (!content) {
    return '';
  }
  const text: string[] = [];

  for (const contentItem of content) {
    if (contentItem.type === 'text' && contentItem.text) {
      text.push(contentItem.text.trim());
    } else if (isRichTextParentType(contentItem)) {
      text.push(extractText(contentItem.content));
    }
  }

  return text.filter((x) => x.trim()).join(' ');
}

export function isRichTextParentType(o: unknown): o is RichtextContentWithChildContent {
  return (
    !!o &&
    !!(o as RichtextContentWithChildContent).content &&
    Array.isArray((o as RichtextContentWithChildContent).content)
  );
}

export function isHeading(content: RichtextContent) {
  return content.type === 'heading';
}
